// popularVideos.js
import { createApp } from 'vue'
import { getPinia } from '@/shared/pinia'
import InteractieveKaart from './InteractieveKaart.vue'

const el = document.getElementById('interactieve-kaart')

if (el) {
  const app = createApp(InteractieveKaart)
  app.use(getPinia())
  app.mount(el)
}
